import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../shared/services/api.service";
import { Urls } from "../../utils/urls";
import { ToastrService } from "ngx-toastr";
import { response } from 'express';
import { CommonDataService } from "@shared/services/common-data.service";
import { error } from 'protractor';
import { environment } from '../../../environments/environment.prod'
import { No_branches_are_available_for_Selected_State,
         No_data_found_for_the_selected_city,
         Something_went_wrong } from "@root/app.constant"

@Component({
  selector: "app-contact-us",
  templateUrl: "./contact-us.component.html",
  styleUrls: ["./contact-us.component.scss"],
})
export class ContactUsComponent implements OnInit {
  userData = {
    state: "",
    city: "",
  };
  contactData = {
    helpLines: [
      {
        key: "Toll-free Number",
        value: "1800-266-9603",
      },
      {
        key: "Board Line Number",
        value: "022 69153500",
      },
      {
        key: "Working Hours",
        value: "Monday to Saturday - 9:30 AM to 06:00 PM",
      },
    ],
    mailUs: [
      {
        mailId: "For investors: mfassist@itiorg.com",
      },
      {
        mailId: "For distributors: mypartner@itiorg.com",
      },
    ],
    grievance: {
      name: "Ms. Nimisha Keny",
      phone: "022 69153500",
      email: "mfassist@itiorg.com",
    },
  };
  stateList = [];
  
  cityList = [];
 
  subContacts: any = [];

  defaultCoordinate = {
    "latitude": 19.0056944,
    "longitude": 72.8281456
  }

  constructor(public apiService: ApiService, 
              private toastr: ToastrService,
              private commonDataService: CommonDataService) {}

  ngOnInit() {
    this.getStates();
  }

  getStates = () => {
    this.commonDataService.loaderStatus.next(true);
    this.apiService.getData(Urls.getState).subscribe(
      response => {
        this.stateList = response.data.stateList;
        this.commonDataService.loaderStatus.next(false);
      },
      error => {
        this.commonDataService.loaderStatus.next(false);
      }
    );
  };

  getCity = () => {
    this.subContacts = [];
    this.userData.city = "";
    this.commonDataService.loaderStatus.next(true);
    this.apiService.postData(Urls.getCity, { stateId: this.userData.state }).subscribe(
      response => {
        this.cityList = response.data.cityList;
        this.commonDataService.loaderStatus.next(false);
      },
      error => {
        if(error.status === -1){
          this.cityList = [];
          if(this.cityList){
            this.toastr.error(No_branches_are_available_for_Selected_State);
          }
        }
        this.commonDataService.loaderStatus.next(false);
      }
    );
  };

  getContactOffice = () => {
    if (this.userData.city === "") {
      this.subContacts = [];
      this.userData.city = "";
    } else {
          this.apiService.postData(Urls.getContactPerson, {cityId: this.userData.city}).subscribe(
          response => {
            if (response.status === 0) {
              this.subContacts = response.data.acceptanceReturn;
            } else {
              this.resetSubContactData();
              this.toastr.error(No_data_found_for_the_selected_city);
            }
          },
          error => {
            if(error.error.errorMessage === null || error.errorMessage === ''){
              this.toastr.error(Something_went_wrong);
            }else{
              this.toastr.error(error.error.errorMessage);
            }
            this.resetSubContactData();
          }
        )
    }
  };

  public resetSubContactData(){
    this.subContacts = [];
  }

  investOnline = () => {
    if(!environment.isDRBuild){
      window.open("https://investonline.itiamc.com/", "_blank");
    }else{
      window.open("https://drinvestor.itiamc.com/", "_blank"); //DR-inv
    }  
  };

  public getNumber(value: any){
    return value ? parseFloat(value) : 0;
  }
}

